/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VerificationDecisionDto } from '../models/verification-decision-dto';


/**
 * API to approve/reject provider response for verification
 */
@Injectable({
  providedIn: 'root',
})
export class VerificationDecisionService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation approveOrRejectVerificationResponse
   */
  static readonly ApproveOrRejectVerificationResponsePath = '/verifications';

  /**
   * Approve or reject verification response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveOrRejectVerificationResponse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveOrRejectVerificationResponse$Response(params: {
    body: VerificationDecisionDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationDecisionService.ApproveOrRejectVerificationResponsePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Approve or reject verification response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveOrRejectVerificationResponse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveOrRejectVerificationResponse(params: {
    body: VerificationDecisionDto
  },
  context?: HttpContext

): Observable<void> {

    return this.approveOrRejectVerificationResponse$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
